export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            意见反馈、片源建议、商务合作，欢迎随时联系我们
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-2/5 bg-gradient-to-br from-primary-500 to-accent-500 p-8 md:p-10 flex flex-col justify-center">
                <div className="w-12 h-12 flex items-center justify-center bg-background-50/20 rounded-xl mb-5">
                  <i className="ri-mail-send-line text-2xl text-background-50"></i>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-3">
                  期待你的声音
                </h3>
                <p className="text-sm text-background-50/80 leading-relaxed mb-6">
                  无论是对麻花影院免费观看的功能建议，还是想推荐的影片内容，都欢迎通过以下方式与我们取得联系。
                </p>
                <div className="space-y-3">
                  <div className="flex items-center gap-3 text-background-50/90">
                    <i className="ri-mail-line text-lg"></i>
                    <span className="text-sm">feedback@mahuacinema.com</span>
                  </div>
                  <div className="flex items-center gap-3 text-background-50/90">
                    <i className="ri-wechat-line text-lg"></i>
                    <span className="text-sm">麻花影院官方公众号</span>
                  </div>
                  <div className="flex items-center gap-3 text-background-50/90">
                    <i className="ri-weibo-line text-lg"></i>
                    <span className="text-sm">@麻花影院官方微博</span>
                  </div>
                </div>
              </div>
              <div className="lg:w-3/5 p-8 md:p-10">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">你的称呼</label>
                    <input
                      type="text"
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入昵称"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                    <input
                      type="email"
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入邮箱"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">反馈内容</label>
                    <textarea
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                      rows={4}
                      placeholder="请描述你的建议或意见……"
                    ></textarea>
                  </div>
                  <button
                    type="button"
                    className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    提交反馈
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}